export default function Board() {
    return (
        <div>
         

            <div className="divboard">



                <div className="boards">
                    <h2 className="titleboard">Missão </h2>
               
                    <h2 className="subboards">A H2L, tem a missão de impulsionar o progresso por meio de soluções de <strong className="s">engenharia</strong> criativas, econômicas e <strong className="s">sustentáveis.</strong></h2>
                </div>
                <div className="boards">
                    <h2 className="titleboard">Visão</h2>
             
                    <h2 className="subboards">Contribuir com o desenvolvimento de <strong className="s">comunidades</strong>, gerar
                        valores, impulsionar novos <strong className="s">negócios</strong> e parcerias.</h2>
                </div>


            </div>
        </div>)
}